export function objectToString<T>(input: T): string {
    return Object
        .keys(input)
        .filter(key => (input as any)[key] !== undefined)
        .map(key => key + '=' + (input as any)[key])
        .join('&');
}
